import type {
    ResolveCommerceStorefrontRequest,
    ResolveCommerceStorefrontResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";
export const resolveCommerceStorefrontOperation: CommerceOperation<
    ResolveCommerceStorefrontRequest,
    ResolveCommerceStorefrontResponse
> = Object.freeze({ name: "commerce.storefront.resolve" });
